<template>
  <ui-sidebar :links="sidebar_links" />
</template>

<script>
export default {
  name: 'UiSettingsSidebar',
  data() {
    return {
      sidebar_links: [
        { title: 'Настройки', route: 'settings.index', icon: 'el-icon-setting' },
        { title: 'Справочники', route: 'settings.dict_types.index', icon: 'el-icon-folder-opened' },
      ],
    };
  },
};
</script>

<style scoped>

</style>
